var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUdpLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B0D439A1-9FF0-4F9C-ACF5-527DEEDA407B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landingpage",
    transform: "translate(-317.000000, -5685.000000)",
    fill: "#DD6725",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-36",
    transform: "translate(0.000000, 4798.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plugins-Copy",
    transform: "translate(273.000000, 325.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(1.000000, 531.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11-Copy-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.4555556,35.9444444 L71.4555556,35.9444444 C71.3777778,35.9888889 71.3,36.0222222 71.2111111,36.0555556 C71.2111111,36.0555556 71.4222222,35.9555556 71.4555556,35.9444444 Z M93,31 C86.9180756,31 81.0914558,32.0949733 75.7016907,34.0863497 L75.6960172,34.0750028 C74.0677408,34.6763872 72.56428,35.323159 71.0267786,36.089073 C72.6266878,35.3401793 73.8634971,36.985476 73.9485987,39.8278679 L73.9485987,80.9943266 C73.9485987,91.5128787 82.4757744,100.040054 92.9943266,100.040054 C103.512879,100.040054 112.040054,91.5128787 112.040054,80.9943266 L112.040054,60.9500738 L106.168047,60.9500738 L119.364462,45.0701237 L119.614093,44.775105 L119.755929,44.5992284 L133.34381,60.9500738 L127.46613,60.9500738 L127.46613,79.1674799 C127.494497,79.7745376 127.517191,80.3872688 127.517191,81.0056734 C127.517191,100.074095 112.057075,115.528537 92.9943266,115.528537 C73.9259049,115.528537 58.4714626,100.074095 58.4714626,81.0056734 C58.4714626,80.4496766 58.4884829,79.8993532 58.5168501,79.3490298 L58.5168501,51.384659 C58.5168501,47.3281516 56.5254737,46.9820719 55.867355,47.5550891 C55.867355,47.5550891 55.8446613,47.5721094 55.8446613,47.5721094 C47.8678089,56.4283445 43,68.1383184 43,81 C43,108.612618 65.3873823,131 93,131 C120.612618,131 143,108.612618 143,81 C143,53.3873823 120.612618,31 93,31 Z",
    id: "udp-logo"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUdpLogo);
export default __webpack_public_path__ + "static/media/udp-logo.87d13b1f34c3e800cecbcf94dab33755.svg";
export { ForwardRef as ReactComponent };